export enum NBAActionType {
  COMPLETE_BASIC_PROFILE = "COMPLETE_BASIC_PROFILE",
  REVIEW_ALLERGY_CONFLICT = "REVIEW_ALLERGY_CONFLICT",
  COMPLETE_EMERGENCY_CARD = "COMPLETE_EMERGENCY_CARD",
  ADD_KNOWN_ALLERGIES = "ADD_KNOWN_ALLERGIES",
  SET_FOLLOWUP_APPOINTMENT_REMINDER = "SET_FOLLOWUP_APPOINTMENT_REMINDER",
  SET_MEDICATION_REMINDER = "SET_MEDICATION_REMINDER",
  UPLOAD_RECORDS = "UPLOAD_RECORDS",
  SET_VACCINATION_REMINDER = "SET_VACCINATION_REMINDER",
  ADD_LONG_TERM_CONDITIONS = "ADD_LONG_TERM_CONDITIONS",
  ADD_SURGERY_HISTORY = "ADD_SURGERY_HISTORY",
  UPDATE_VITALS = "UPDATE_VITALS",
  SET_UP_VACCINATION_TRACKER = "SET_UP_VACCINATION_TRACKER",
  UPDATE_VACCINATION_STATUS = "UPDATE_VACCINATION_STATUS",
  READ_FAMILY_NOTE = "READ_FAMILY_NOTE",
  GRANT_PROFILE_ACCESS = "GRANT_PROFILE_ACCESS",
  GENERATE_HEALTH_SUMMARY = "GENERATE_HEALTH_SUMMARY",
  ADD_HEALTH_MEMORY = "ADD_HEALTH_MEMORY",
  ADD_CHILD_HEALTH_MEMORY = "ADD_CHILD_HEALTH_MEMORY",
  SET_INSURANCE_RENEWAL_REMINDER = "SET_INSURANCE_RENEWAL_REMINDER",
  MAKE_DOCUMENT_OFFLINE = "MAKE_DOCUMENT_OFFLINE",
  MARK_DOCUMENT_FAVORITE = "MARK_DOCUMENT_FAVORITE",
  ADD_FAMILY_MEMBER = "ADD_FAMILY_MEMBER",
  RESEND_FAMILY_INVITE = "RESEND_FAMILY_INVITE",
  LINK_WHATSAPP = "LINK_WHATSAPP",
  LINK_EMAIL = "LINK_EMAIL",
}

export enum NBACType {
  UPDATE_BASIC_PROFILE = "UPDATE_BASIC_PROFILE",
  REVIEW_HEALTH_PROFILE = "REVIEW_HEALTH_PROFILE",
  COMPLETE_EMERGENCY_CARD = "COMPLETE_EMERGENCY_CARD",
  UPDATE_HEALTH_PROFILE = "UPDATE_HEALTH_PROFILE",
  SET_REMINDER = "SET_REMINDER",
  UPLOAD_DOCUMENT = "UPLOAD_DOCUMENT",
  UPDATE_VITALS = "UPDATE_VITALS",
  UPDATE_VACCINATION = "UPDATE_VACCINATION",
  READ_FAMILY_NOTE = "READ_FAMILY_NOTE",
  GRANT_ACCESS = "GRANT_ACCESS",
  GENERATE_HEALTH_SUMMARY = "GENERATE_HEALTH_SUMMARY",
  ADD_MEMORY = "ADD_MEMORY",
  ENTER_HEALTH_MEMORY = "ENTER_HEALTH_MEMORY",
  MANAGE_DOCUMENT = "MANAGE_DOCUMENT",
  ADD_MEMBER = "ADD_MEMBER",
  RESEND_INVITE = "RESEND_INVITE",
  LINK_WHATSAPP = "LINK_WHATSAPP",
  LINK_EMAIL = "LINK_EMAIL",
}

export enum NBAActionType {
  NAVIGATE = "NAVIGATE",
  OPEN_MODAL = "OPEN_MODAL",
  TRIGGER_FUNCTION = "TRIGGER_FUNCTION",
}

export interface NBACTAConfig {
  actionType: NBAActionType;
  url?: string;
  label: string;
  icon?: string;
  params?: Record<string, any>;
  modalType?: string;
  functionName?: string;
}

export const NBACTALabels: Record<NBACType, string> = {
  [NBACType.UPDATE_BASIC_PROFILE]: "Update Basic Profile",
  [NBACType.REVIEW_HEALTH_PROFILE]: "Review Health Profile",
  [NBACType.COMPLETE_EMERGENCY_CARD]: "Complete Emergency Card",
  [NBACType.UPDATE_HEALTH_PROFILE]: "Update Health Profile",
  [NBACType.SET_REMINDER]: "Set Reminder",
  [NBACType.UPLOAD_DOCUMENT]: "Upload Document",
  [NBACType.UPDATE_VITALS]: "Update Vitals",
  [NBACType.UPDATE_VACCINATION]: "Update Vaccination",
  [NBACType.READ_FAMILY_NOTE]: "Read Family Note",
  [NBACType.GRANT_ACCESS]: "Grant Access",
  [NBACType.GENERATE_HEALTH_SUMMARY]: "Generate Health Summary",
  [NBACType.ADD_MEMORY]: "Add Memory",
  [NBACType.ENTER_HEALTH_MEMORY]: "Enter Health Memory",
  [NBACType.MANAGE_DOCUMENT]: "Manage Document",
  [NBACType.ADD_MEMBER]: "Add Member",
  [NBACType.RESEND_INVITE]: "Resend Invite",
  [NBACType.LINK_WHATSAPP]: "Link WhatsApp",
  [NBACType.LINK_EMAIL]: "Link Email",
};

export const NBACTAConfigs: Record<NBACType, NBACTAConfig> = {
  [NBACType.UPDATE_BASIC_PROFILE]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/profile/basic-information",
    label: "Update Basic Profile",
    icon: "user",
  },
  [NBACType.REVIEW_HEALTH_PROFILE]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/profile/health-profile",
    label: "Review Health Profile",
    icon: "heart",
  },
  [NBACType.COMPLETE_EMERGENCY_CARD]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/profile/emergency-card/activate",
    label: "Complete Emergency Card",
    icon: "medical-cross",
  },
  [NBACType.UPDATE_HEALTH_PROFILE]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/profile/health-profile",
    label: "Update Health Profile",
    icon: "edit",
  },
  [NBACType.SET_REMINDER]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/reminders",
    label: "Set Reminder",
    icon: "clock",
  },
  [NBACType.UPLOAD_DOCUMENT]: {
    actionType: NBAActionType.OPEN_MODAL,
    modalType: "DOCUMENT_UPLOAD",
    label: "Upload Document",
    icon: "folder",
  },
  [NBACType.UPDATE_VITALS]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/profile/basic-information/vitals",
    label: "Update Vitals",
    icon: "activity",
  },
  [NBACType.UPDATE_VACCINATION]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/profile/vaccinations",
    label: "Update Vaccination",
    icon: "shield",
  },
  [NBACType.READ_FAMILY_NOTE]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/family/notes",
    label: "Read Family Note",
    icon: "message-circle",
  },
  [NBACType.GRANT_ACCESS]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/family/access",
    label: "Grant Access",
    icon: "users",
  },
  [NBACType.GENERATE_HEALTH_SUMMARY]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/health-summary",
    label: "Generate Health Summary",
    icon: "file-text",
  },
  [NBACType.ADD_MEMORY]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/health-memories",
    label: "Add Memory",
    icon: "plus-circle",
  },
  [NBACType.ENTER_HEALTH_MEMORY]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/health-memories",
    label: "Enter Health Memory",
    icon: "heart",
  },
  [NBACType.MANAGE_DOCUMENT]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/documents",
    label: "Manage Document",
    icon: "folder",
  },
  [NBACType.ADD_MEMBER]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/profile/family/add-member",
    label: "Add Member",
    icon: "user-plus",
  },
  [NBACType.RESEND_INVITE]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/profile/family/add-member",
    label: "Resend Invite",
    icon: "send",
  },
  [NBACType.LINK_WHATSAPP]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/settings/notifications",
    label: "Link WhatsApp",
    icon: "message-square",
  },
  [NBACType.LINK_EMAIL]: {
    actionType: NBAActionType.NAVIGATE,
    url: "/settings/notifications",
    label: "Link Email",
    icon: "mail",
  },
};

// Helper function to get CTA config with dynamic params
export const getNBACTAConfig = (ctaType: NBACType, metadata?: any): NBACTAConfig => {
  const baseConfig = NBACTAConfigs[ctaType];
  
  // Add dynamic params based on metadata
  let url = baseConfig.url;
  if (url && metadata) {
    const params = new URLSearchParams();
    if (metadata.documentId) {
      params.append('documentId', metadata.documentId);
    }
    if (metadata.prescriptionId) {
      params.append('prescriptionId', metadata.prescriptionId);
    }
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
  }

  return {
    ...baseConfig,
    url,
    params: metadata,
  };
};
